<template>
    <Forms ref="frmSearch"
            title="Busca por Cadastro"
            :showHelp="true"
            :showClearButton="true"
            :showSearchButton="true"
            :showNewButton="true"
            :ShowFooterImbo="true"
            v-on:Clear="onClearSection"
            v-on:Search="Search"
            >
            <div class="form-inputs">
                <label class="labelsearch">Código {{ qma === 0 ? 'LV' : qma === 1 ? 'PIT' : 'PIVS' }}</label>
                <b-input :placeholder="'Informe o código ' +  (qma === 0 ? 'LV' : qma === 1 ? 'PIT' : 'PIVS')"  v-model="formSearch.numeroQma"/>
            </div>
            <div class="form-inputs">
                <label class="labelsearch">Código da Obra</label>
                <autocomplete-z ref="obraRHTypeahead"
                          placeholder="Digite o nome da Obra"
                          iconClass="fas fa-hard-hat"
                          :serializer="(obra) => obra.referencia"
                          :debounceLength="1"
                          :formField="formSearch.form.obraid"
                          v-on:search="onSearchObra"
                          :ShowCode="false"
                          v-on:changeCode="onChangeCodeObra"/>
            </div>
            <div class="form-inputs">
                <label class="labelsearch">Busca por Local / Quadra / Lote / Obra</label>
                <b-input placeholder="Ex: QD-07, ZR6, L1.0003/23..." v-model="formSearch.buscaLivre"/>
            </div>
            <div class="form-inputs">
                <label class="labelsearch">Status</label>
                <select v-model="formSearch.status" class="form-control">
                  <option :value="null" disabled>Selecione um status</option>
                  <option v-for="data in statusQma" :key="data.value" :value="data.value">{{data.text}}</option>
                </select>
            </div>
            <div class="form-inputs">
                <label class="labelsearch">Data de Envio</label>
                <div class="d-flex align-items-end" >
                    <b-form-datepicker
                        ref = "DataInicio"
                        placeholder="__/__/__"
                        locale="pt-BR"
                        v-model="formSearch.dataInicio"
                        :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                    ></b-form-datepicker>
                    <label class="labelseach ml-1 mr-1" > à </label>
                    <b-form-datepicker
                        placeholder="__/__/__"
                        locale="pt-BR"
                        v-model="formSearch.dataFim"
                        :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                    ></b-form-datepicker>
                </div>
            </div>

            <div class="form-inputs header-filters-block">
                <hr class="hf-divider" />
                <label class="labelsearch hf-section-title">Filtro de Cabeçalho</label>

                <label class="hf-sub-label">Template ({{ qma === 0 ? 'LV' : qma === 1 ? 'PIT' : 'PIVS' }})</label>
                <multiselect
                    v-model="selectedTemplate"
                    :options="templateOptions"
                    :loading="loadingTemplates"
                    :multiple="false"
                    :allow-empty="true"
                    placeholder="Selecione um template"
                    label="display"
                    track-by="id"
                    selectLabel=""
                    deselectLabel=""
                    selectedLabel=""
                    :show-labels="false"
                    @input="onTemplateChange">
                    <span slot="noResult">Nenhum template encontrado</span>
                    <span slot="noOptions">
                        {{ loadingTemplates ? 'Carregando templates...' : 'Nenhum ' + (qma === 0 ? 'LV' : qma === 1 ? 'PIT' : 'PIVS') + ' preenchido com cabeçalho' }}
                    </span>
                </multiselect>

                <template v-if="selectedTemplate">
                    <div class="hf-add" v-if="availableFields.length > 0">
                        <select class="form-control form-control-sm" v-model="newFieldToAdd" @change="addHeaderFilter">
                            <option :value="null">+ Adicionar filtro do cabeçalho</option>
                            <option v-for="f in availableFields" :key="f.descricao" :value="f">{{ (f.descricao || '').trim() }}</option>
                        </select>
                    </div>

                    <div v-for="(hf, i) in headerFilters" :key="'hf-'+i" class="hf-row">
                        <div class="hf-row-head">
                            <span class="hf-tag" :class="hf.tipo === 1 ? 'hf-tag-num' : hf.tipo === 2 ? 'hf-tag-date' : 'hf-tag-text'">
                                {{ hf.tipo === 1 ? '#' : hf.tipo === 2 ? '📅' : 'a' }}
                            </span>
                            <span class="hf-name">{{ hf.descricao }}</span>
                            <button class="hf-remove" type="button" @click="removeHeaderFilter(i)" title="Remover filtro">✕</button>
                        </div>
                        <b-input v-if="hf.tipo === 0" v-model="hf.valor" :placeholder="'Filtrar por ' + hf.descricao.trim()" size="sm" />
                        <b-input v-else-if="hf.tipo === 1" type="number" v-model="hf.valor" placeholder="Número" size="sm" />
                        <b-form-datepicker v-else-if="hf.tipo === 2" v-model="hf.valor" locale="pt-BR" placeholder="__/__/__"
                            :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }" />
                    </div>
                </template>
            </div>
    </Forms>
    </template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import Multiselect from 'vue-multiselect'
import { loading } from '@/shared/utils/UIHelper'
import Roles from '@/shared/utils/roles.js'
import inqueryQmaRepository from '@/shared/http/repositories/business/qmaInquery'

export default {
  name: 'inqueryQmaFilter',
  components: { AutocompleteZ, Multiselect },
  mixins: [ ActionsForm, ExpenseMixin ],
  props: ['qma'],
  data () {
    return {
      roles: Roles,
      formSearch: {
        codigo: null,
        status: null,
        local: null,
        buscaLivre: null,
        dataInicio: null,
        dataFim: null,
        revisao: null,
        equipamento: null,
        numeroQma: null,
        form: {
          ResponsavelId: {
            value: null,
            options: [],
            required: false,
            state: null,
            code: null
          },
          obraid: {
            value: null,
            options: [],
            required: false,
            state: null,
            code: null
          }
        }
      },
      statusQma: [],
      selectedTemplate: null,
      templateOptions: [],
      loadingTemplates: false,
      headerFields: [],
      headerFilters: [],
      newFieldToAdd: null
    }
  },
  computed: {
    storageKey () {
      // key por fluxo — LV(0)/PIT(1)/PIVS(2) são telas separadas, não podem vazar filtro entre si
      return `zc-qma-inquery-filter-${this.qma}`
    },
    availableFields () {
      const used = this.headerFilters.map(f => f.descricao)
      return this.headerFields.filter(f => !used.includes(f.descricao))
    }
  },
  watch: {
    qma () {
      this.resetTemplate()
      this.loadTemplates()
    }
  },
  mounted () {
    this.GetStatusQma()
    this.loadTemplates()
    const restored = this.restoreFilters()
    if (this.hasRole(this.roles.QMA_RESEARCH_TECHNICIAN_VIEW)) {
      this.formSearch.isTechnical = true
    }
    // O filtro é o ÚNICO disparador do load da grid (a tabela não busca mais no
    // proprio mount). Assim ha UM só fetch: vazio na 1a visita, filtrado no restore —
    // elimina a corrida que fazia a busca sem-filtro sobrescrever o grid filtrado.
    // nextTick: garante que a arvore (filtro + tabela) montou e os refs ja existem.
    this.$nextTick(() => {
      if (restored && this._restoredObra && this._restoredObra.referencia && this.$refs.obraRHTypeahead) {
        this.$refs.obraRHTypeahead.setValue(this._restoredObra)
      } else if (restored && this._restoredObraTexto && this.$refs.obraRHTypeahead) {
        // Código digitado sem seleção: repõe o texto no autocomplete pro Search reenviar.
        this.$refs.obraRHTypeahead.query = this._restoredObraTexto
        this.$refs.obraRHTypeahead.noSearch = true
      }
      this.Search()
    })
  },
  methods: {
    Search () {
      // Obra: manda o GUID quando o usuário selecionou da lista; senão manda o texto
      // digitado (código/referência) pro backend resolver. Antes, digitar o código sem
      // clicar na sugestão mandava null e o filtro era ignorado (voltava tudo).
      const obraDigitada = this.$refs.obraRHTypeahead ? (this.$refs.obraRHTypeahead.query || '').trim() : ''
      const obra = this.formSearch.form.obraid.value || (obraDigitada.length ? obraDigitada : null)
      this.$emit('search', {
        NumeroQma: this.formSearch.numeroQma,
        Fluxo: this.qma,
        CodigoAtividade: this.formSearch.codigo,
        Obra: obra,
        ResponsavelId: this.formSearch.form.ResponsavelId.value,
        StatusQMA: this.formSearch.status,
        Local: this.formSearch.local,
        BuscaLivre: this.formSearch.buscaLivre,
        dataInicio: this.formSearch.dataInicio,
        dataFinal: this.formSearch.dataFim,
        equipamento: this.formSearch.equipamento,
        Revisao: this.formSearch.revisao,
        QmaTemplateId: this.selectedTemplate ? this.selectedTemplate.id : null,
        HeaderFilters: this.headerFilters
          .filter(hf => hf.valor !== null && hf.valor !== '' && hf.valor !== undefined)
          .map(hf => ({
            descricao: hf.descricao,
            tipo: hf.tipo,
            valor: String(hf.valor)
          }))
      })
      this.persistFilters()
    },
    onClearSection () {
      this.formSearch.codigo = null
      this.formSearch.form.ResponsavelId.value = null
      this.formSearch.form.ResponsavelId.options = null
      this.formSearch.form.ResponsavelId.required = null
      this.formSearch.form.ResponsavelId.state = null
      this.formSearch.form.ResponsavelId.code = null
      // clear() do autocomplete não zera o value (só o debounce de 800ms zera, tarde demais
      // pro Search síncrono abaixo) — zera explícito senão a obra antiga vaza na busca limpa
      this.formSearch.form.obraid.value = null
      this.formSearch.form.obraid.code = null
      this.$refs.obraRHTypeahead.clear()
      this.formSearch.status = null
      this.formSearch.local = null
      this.formSearch.buscaLivre = null
      this.formSearch.matriz = null
      this.formSearch.dataInicio = null
      this.formSearch.dataFim = null
      this.formSearch.revisao = null
      this.formSearch.equipamento = null
      this.formSearch.numeroQma = null
      this.resetTemplate()
      window.sessionStorage.removeItem(this.storageKey)
      this.Search()
    },
    persistFilters () {
      try {
        const obraLabel = this.$refs.obraRHTypeahead ? this.$refs.obraRHTypeahead.query : null
        // merge: a tabela grava `page` nesta mesma chave. Sobrescrever o objeto
        // inteiro aqui apagaria a página salva — preservo o que já estiver lá.
        const raw = window.sessionStorage.getItem(this.storageKey)
        const prev = raw ? (JSON.parse(raw) || {}) : {}
        window.sessionStorage.setItem(this.storageKey, JSON.stringify({
          ...prev,
          formSearch: this.formSearch,
          obraLabel,
          selectedTemplate: this.selectedTemplate,
          headerFields: this.headerFields,
          headerFilters: this.headerFilters
        }))
      } catch (e) {
        // storage indisponível (quota/modo privado) — persistência é best-effort, não quebra a busca
      }
    },
    restoreFilters () {
      try {
        const raw = window.sessionStorage.getItem(this.storageKey)
        if (!raw) return false
        const s = JSON.parse(raw)
        if (!s) return false
        if (s.formSearch) this.formSearch = s.formSearch
        if (s.selectedTemplate) this.selectedTemplate = s.selectedTemplate
        if (Array.isArray(s.headerFields)) this.headerFields = s.headerFields
        if (Array.isArray(s.headerFilters)) this.headerFilters = s.headerFilters
        const obraid = s.formSearch && s.formSearch.form && s.formSearch.form.obraid
        this._restoredObra = (obraid && obraid.value)
          ? { id: obraid.value, codigo: obraid.code, referencia: s.obraLabel }
          : null
        // Obra filtrada por código digitado (sem seleção) não tem GUID; guarda o texto
        // pra repor no restore, senão o filtro de obra some ao voltar do detalhe.
        this._restoredObraTexto = (obraid && obraid.value) ? null : (s.obraLabel || null)
        return true
      } catch (e) {
        return false
      }
    },
    GetStatusQma () {
      loading.push()
      inqueryQmaRepository.GetAllStatusQma()
        .then((Response) => {
          loading.pop()
          this.statusQma = [...Response.data]
        })
        .catch((Error) => {
          console.error(Error)
        })
    },
    loadTemplates () {
      this.loadingTemplates = true
      this.templateOptions = []
      inqueryQmaRepository.GetTemplatesByFluxo(this.qma)
        .then(Response => {
          this.loadingTemplates = false
          this.templateOptions = (Response.data || []).map(t => ({
            id: t.id,
            codigo: t.codigo,
            pes: t.pes,
            display: t.codigo
          }))
        })
        .catch(err => {
          this.loadingTemplates = false
          console.error('Erro carregando templates', err)
        })
    },
    onTemplateChange () {
      this.headerFilters = []
      this.headerFields = []
      this.newFieldToAdd = null
      if (!this.selectedTemplate) return
      inqueryQmaRepository.GetHeaderFieldsByTemplate(this.selectedTemplate.id)
        .then(Response => {
          this.headerFields = Response.data || []
        })
        .catch(err => {
          console.error('Erro carregando campos do cabeçalho', err)
        })
    },
    addHeaderFilter () {
      if (!this.newFieldToAdd) return
      const f = this.newFieldToAdd
      this.headerFilters.push({
        descricao: f.descricao,
        tipo: f.tipo,
        ordem: f.ordem,
        valor: null
      })
      this.newFieldToAdd = null
    },
    removeHeaderFilter (index) {
      this.headerFilters.splice(index, 1)
    },
    resetTemplate () {
      this.selectedTemplate = null
      this.headerFilters = []
      this.headerFields = []
      this.newFieldToAdd = null
    }
  }
}

</script>

    <style scoped>
    .form-inputs{
        width: 100%;
        padding: 0.5rem 0;
    }
    .labelsearch{
        font-weight: 700;
        color: #666;
        font-size: 14px;
        margin-bottom: 5px;
        padding-bottom: 0;
        font-family: 'Segoe UI';
    }
    .header-filters-block {
        padding-top: 0.25rem;
    }
    .hf-divider {
        border-top: 1px dashed #c9c9c9;
        margin: 0.5rem 0 0.75rem;
    }
    .hf-section-title {
        color: #008144;
        font-size: 13px;
        text-transform: uppercase;
        letter-spacing: 0.3px;
        display: block;
        margin-bottom: 0.5rem;
    }
    .hf-sub-label {
        font-size: 12px;
        font-weight: 600;
        color: #666;
        margin-bottom: 4px;
        display: block;
        font-family: 'Segoe UI';
    }
    .hf-row {
        background: #f7f8f7;
        border: 1px solid #e4e6e4;
        border-radius: 4px;
        padding: 6px 8px;
        margin-bottom: 6px;
        margin-top: 10px;
    }
    .header-filters-block .multiselect {
        margin-bottom: 12px;
        font-size: 13px;
        min-height: 32px;
    }
    .header-filters-block ::v-deep .multiselect__tags {
        min-height: 32px;
        padding: 4px 36px 0 8px;
        font-size: 13px;
    }
    .header-filters-block ::v-deep .multiselect__single,
    .header-filters-block ::v-deep .multiselect__placeholder,
    .header-filters-block ::v-deep .multiselect__input,
    .header-filters-block ::v-deep .multiselect__option {
        font-size: 13px;
        padding: 4px 8px;
        margin-bottom: 0;
        line-height: 1.4;
    }
    .header-filters-block ::v-deep .multiselect__select {
        height: 30px;
    }
    .header-filters-block .hf-row:first-of-type {
        margin-top: 14px;
    }
    .hf-add {
        margin-top: 10px;
    }
    .hf-row-head {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-bottom: 4px;
    }
    .hf-tag {
        display: inline-block;
        min-width: 18px;
        text-align: center;
        font-size: 11px;
        font-weight: bold;
        background: #d3eddc;
        color: #155724;
        padding: 1px 6px;
        border-radius: 3px;
    }
    .hf-tag-num { background: #d3eddc; }
    .hf-tag-text { background: #d3eddc; }
    .hf-tag-date { background: #e0e0ff; color: #1a237e; }
    .hf-name {
        flex: 1;
        font-size: 12px;
        font-weight: 600;
        color: #444;
        text-transform: uppercase;
        font-family: 'Segoe UI';
    }
    .hf-remove {
        border: none;
        background: transparent;
        color: #b60000;
        font-size: 14px;
        line-height: 1;
        cursor: pointer;
        padding: 0 4px;
    }
    .hf-remove:hover { color: #7d1f15; }
    .hf-empty {
        font-size: 11px;
        color: #888;
        font-style: italic;
        padding: 4px 0;
    }
    </style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/components/inqueryQmaFilter/inqueryQmaFilter.vue